import { render, staticRenderFns } from "./knowledge-chart.vue?vue&type=template&id=783f8e05&scoped=true"
import script from "./knowledge-chart.vue?vue&type=script&lang=js"
export * from "./knowledge-chart.vue?vue&type=script&lang=js"
import style0 from "./knowledge-chart.vue?vue&type=style&index=0&id=783f8e05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783f8e05",
  null
  
)

export default component.exports